const CategoryName__Title = categoryName => {
  return categoryName
    .replace("and", "&")
    .split("-")
    .map(word => word[0].toUpperCase() + word.slice(1))
    .join(" ");
};

export default CategoryName__Title;
